import React from 'react';
import { Globe } from 'lucide-react';
import { Button } from './ui/button';

const LanguageSwitcher = ({ currentLang, onLanguageChange }) => {
  return (
    <div className="flex items-center gap-2">
      <Globe className="w-4 h-4 text-gray-600" />
      <div className="flex gap-1">
        <Button
          variant={currentLang === 'ro' ? 'default' : 'ghost'}
          size="sm"
          onClick={() => onLanguageChange('ro')}
          className="h-8 px-3 text-sm font-medium"
        >
          RO
        </Button>
        <Button
          variant={currentLang === 'en' ? 'default' : 'ghost'}
          size="sm"
          onClick={() => onLanguageChange('en')}
          className="h-8 px-3 text-sm font-medium"
        >
          EN
        </Button>
      </div>
    </div>
  );
};

export default LanguageSwitcher;
